import React, { useState, useEffect, useRef } from "react";
import Cards from "./Cards";
import { FaSearch, FaBars, FaChevronRight } from "react-icons/fa";
import "./NavbarHome.css";

const Content = (props) => {

  return (
    <div>
      <div className="h-screen flex flex-col overflow-visible content " >       
        {/* Main Content */}
        <div className="flex-1 z-0 p-6 overflow-hidden " id="bgimg" >
          <Cards user={props.user} />
        </div>
      </div>      
    </div >
  );
};

export default Content;
